import { contentMigrationFetchStatus } from '@wix/communities-blog-client-common/dist/src/actions/fetch-status';
import { APP_SETTINGS_MODAL_CLOSED } from '../../app-settings/actions/app-settings-modal-closed';

const appSettingsClosedMiddleware = store => next => action => {
  if (action.type === APP_SETTINGS_MODAL_CLOSED) {
    store.dispatch(contentMigrationFetchStatus());
  }
  return next(action);
};

export default appSettingsClosedMiddleware;
